// @flow
import {
  DISABLE_PERSONALIZED_GOOGLE_ADS,
  INITIALIZE_PERSONALIZED_GOOGLE_ADS,
  HIDE_GDPR_COOKIE_BANNER,
  INITIALIZE_GDPR_COOKIE_BANNER,
} from './actionTypes';

export const disablePersonalizedAds = (): TrovitAction => ({
  type: DISABLE_PERSONALIZED_GOOGLE_ADS,
});

export const initializePersonalizedAds = (personalizedAds: boolean): TrovitAction => ({
  type: INITIALIZE_PERSONALIZED_GOOGLE_ADS,
  payload: {
    personalizedAds,
  },
});

export const hideGdprCookieBanner = (updateStore: boolean): TrovitAction => ({
  type: HIDE_GDPR_COOKIE_BANNER,
  payload: {
    updateStore,
  },
});

export const initializeGdprCookieBanner = (visible: boolean, url: string): TrovitAction => ({
  type: INITIALIZE_GDPR_COOKIE_BANNER,
  payload: {
    visible,
    url,
  },
});



// WEBPACK FOOTER //
// ./app/Gdpr/actions.js